"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (i18n, lang, fallbackLang = 'en') => i18n[lang] || i18n[fallbackLang];
//# sourceMappingURL=getLanguageMap.js.map